"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
exports.default = {
    formItem: {
        display: 'block',
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column-reverse',
        '& input:focus + label': {
            color: tfs_css_variables_1.default.colorBlue,
        },
    },
    alignLabelRight: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '& label': {
            fontWeight: 'normal',
        },
    },
    label: {
        position: 'relative',
        display: 'block',
        margin: '0 0 .7rem',
        fontSize: '1rem',
        fontWeight: 'bold',
        transition: tfs_css_variables_1.default.paceFast + " " + tfs_css_variables_1.default.easeIn + " color",
    },
    required: {
        '&:after': {
            color: tfs_css_variables_1.default.colorWarning,
            content: "'*'",
        },
    },
    error: {
        color: tfs_css_variables_1.default.colorError + " !important",
    },
    errorLabel: {
        margin: '.4rem 0 0',
        fontSize: '.9rem',
    },
};
//# sourceMappingURL=FormItem.styles.js.map